<div class="profile__wrapper">
  <div class="row-wrapper">
    <h3>
      Tech stacks
      <button
        class="button button__add--normal"
        (click)="addTechStack()"
      ></button>
    </h3>
    <div class="item-wrapper">
      <div class="item" *ngFor="let item of techStacks">
        <span class="item__name">{{ item.name }}</span>
        <i class="icon-close" (click)="deleteTechStack(item)"></i>
      </div>
    </div>
  </div>
  <div class="row-wrapper">
    <h3>
      Positions
      <button
        class="button button__add--normal"
        (click)="addPosition()"
      ></button>
    </h3>
    <div class="item-wrapper">
      <div class="item" *ngFor="let item of positions">
        <span class="item__name">{{ item.name }}</span>
        <i class="icon-close" (click)="deletePosition(item)"></i>
      </div>
    </div>
  </div>
  <div class="row-wrapper">
    <h3>
      Frameworks
      <button
        class="button button__add--normal"
        (click)="addFramework()"
      ></button>
    </h3>
    <div class="item-wrapper">
      <div class="item" *ngFor="let item of frameworks">
        <span class="item__name">{{ item.name }}</span>
        <i class="icon-close" (click)="deleteFramework(item)"></i>
      </div>
    </div>
  </div>
</div>
